export default __webpack_public_path__ + "static/media/amparo-arte-1.c785314e.webp";